<template>
  <portal to="tooltips" z-index-class="z-50">
    <modal-component
      :show="true"
      @close="closeModal"
      container-classes="max-w-sm"
      wrapper-classes="bg-white px-10 py-14"
    >
      <slot></slot>
    </modal-component>
  </portal>
</template>

<script>
import ModalComponent from './ModalComponent.vue';

export default {
  components: { ModalComponent },

  methods: {
    closeModal() {
      this.$emit('close');
    },
  },
};
</script>
